import { useEffect } from "react";

/**
 * Crisp live-chat loader.
 *
 * Crisp is a free, full-featured chat widget (https://crisp.chat — free plan
 * = 2 seats, unlimited conversations, mobile apps, knowledge base).
 *
 * Setup:
 *  1. Sign up at https://app.crisp.chat
 *  2. Create a website and copy the WEBSITE_ID (looks like a UUID)
 *  3. Add to /app/frontend/.env (preview) and Emergent prod env vars:
 *       REACT_APP_CRISP_WEBSITE_ID=<your-uuid>
 *  4. Redeploy. The widget appears on every public page automatically.
 *
 * Without REACT_APP_CRISP_WEBSITE_ID set the loader is a no-op — site stays
 * clean. This prevents accidentally shipping a broken-config widget.
 */
export default function CrispChat() {
  useEffect(() => {
    const websiteId = process.env.REACT_APP_CRISP_WEBSITE_ID;
    if (!websiteId) return;
    if (window.$crisp) return;  // already loaded
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = websiteId;
    const s = document.createElement("script");
    s.src = "https://client.crisp.chat/l.js";
    s.async = true;
    s.dataset.testid = "crisp-loader";
    document.head.appendChild(s);
    return () => {
      // Best-effort cleanup if the component ever unmounts (it won't in
      // practice — it's at the App root). Crisp doesn't expose a real
      // teardown so we just remove the loader tag.
      s.remove();
    };
  }, []);
  return null;
}
